export default "/app/themes/macleod/public/images/agent-pattern.svg?2952e56b480c6c49530978ba58d39a33";